// extracted by mini-css-extract-plugin
export default {"div":"cafeteriasFincas_div__ouxir","img":"cafeteriasFincas_img__jS+Cz"};